import { render, staticRenderFns } from "./MainCoin.vue?vue&type=template&id=31837a43&scoped=true"
import script from "./MainCoin.vue?vue&type=script&lang=js"
export * from "./MainCoin.vue?vue&type=script&lang=js"
import style0 from "./MainCoin.vue?vue&type=style&index=0&id=31837a43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31837a43",
  null
  
)

export default component.exports